import { useIntl } from "react-intl";
export const LIMIT_SEARCH = 20;

// Options
export const DOCTOR_SCORE_OPTIONS = [
  { id: 5, value: 5 },
  { id: 4, value: 4 },
  { id: 3, value: 3 },
  { id: 2, value: 2 },
  { id: 1, value: 1 },
];

//code เอามาจากฝั่งเขา เช็คที่ issues 69119
// export const CANCEL_REASON_OPTIONS = [
//   {
//     id: 1,
//     name: "ไม่ต้องการปรึกษาแพทย์แล้ว",
//     value: "06",
//     valuePreVer: "0003",
//     namePreVer:
//       "รพ. : ผู้ป่วยตรวจสอบสิทธิ แต่ไม่รับการรักษา / ยกเลิกการรักษา (ไม่ต้องการปรึกษาแพทย์แล้ว)",
//   },
//   {
//     id: 2,
//     name: "ต้องการเปลี่ยนแพทย์",
//     value: "04",
//     valuePreVer: "0003",
//     namePreVer:
//       "รพ. : ผู้ป่วยตรวจสอบสิทธิ แต่ไม่รับการรักษา / ยกเลิกการรักษา (ต้องการเปลี่ยนแพทย์)",
//   },
//   {
//     id: 3,
//     name: "ต้องการเปลี่ยนประเภทการนัดหมาย",
//     value: "07",
//     valuePreVer: "0003",
//     namePreVer:
//       "รพ. : ผู้ป่วยตรวจสอบสิทธิ แต่ไม่รับการรักษา / ยกเลิกการรักษา (ต้องการเปลี่ยนประเภทการนัดหมาย)",
//   },
//   {
//     id: 4,
//     name: "ไม่สะดวกตามวันเวลาที่นัดหมาย",
//     value: "08",
//     valuePreVer: "0003",
//     namePreVer:
//       "รพ. : ผู้ป่วยตรวจสอบสิทธิ แต่ไม่รับการรักษา / ยกเลิกการรักษา (อื่นๆ)",
//   },
// ];

export const CANCEL_REASON_OPTIONS_DEFAULT = [
  {
    id: 1,
    name_en: "Did not want to consult a doctor anymore.",
    name: "ไม่ต้องการปรึกษาแพทย์แล้ว",
    value: "06",
    valuePreVer: "0003",
    namePreVer:
      "รพ. : ผู้ป่วยตรวจสอบสิทธิ แต่ไม่รับการรักษา / ยกเลิกการรักษา (ไม่ต้องการปรึกษาแพทย์แล้ว)",
  },
  {
    id: 2,
    name_en: "Want to book a different doctor",
    name: "ต้องการเปลี่ยนแพทย์",
    value: "04",
    valuePreVer: "0003",
    namePreVer:
      "รพ. : ผู้ป่วยตรวจสอบสิทธิ แต่ไม่รับการรักษา / ยกเลิกการรักษา (ต้องการเปลี่ยนแพทย์)",
  },
  {
    id: 3,
    name_en: "Want to change appointment type",
    name: "ต้องการเปลี่ยนประเภทการนัดหมาย",
    value: "07",
    valuePreVer: "0003",
    namePreVer:
      "รพ. : ผู้ป่วยตรวจสอบสิทธิ แต่ไม่รับการรักษา / ยกเลิกการรักษา (ต้องการเปลี่ยนประเภทการนัดหมาย)",
  },
  {
    id: 4,
    name_en: "Others",
    name: "ไม่สะดวกตามวันเวลาที่นัดหมาย",
    value: "08",
    valuePreVer: "0003",
    namePreVer:
      "รพ. : ผู้ป่วยตรวจสอบสิทธิ แต่ไม่รับการรักษา / ยกเลิกการรักษา (อื่นๆ)",
  },
];

export const APPOINTMENT_ACTION_OPTIONS = [
  {
    id: 1,
    name: "แก้ไขการนัดหมาย",
  },
  { id: 2, name: "ยกเลิกนัดหมาย" },
];

export const APPOINTMENT_ACTION_OPTIONS_EN = [
  {
    id: 1,
    name: "Change appointment",
  },
  { id: 2, name: "Cancel appointment" },
];

export const DOCTOR_REVIEW_OPTIONS = [
  // { name: "พร้อมให้บริการ" },
  { id: 1, name: "ล่าสุด" },
  { id: 2, name: "เรตติ้ง - มากไปน้อย" },
  { id: 3, name: "เรตติ้ง - น้อยไปมาก" },
];

export const DOCTOR_REVIEW_OPTIONS_EN = [
  // { name: "พร้อมให้บริการ" },
  { id: 1, name: "Latest" },
  { id: 2, name: "Rating - High to Low." },
  { id: 3, name: "Rating - Low to High." },
];

export const DOCTOR_SORT_OPTIONS = [
  // { name: "พร้อมให้บริการ" },
  // { id: 1, name: "ใกล้ฉัน" },
  { id: 1, name: "ราคา-ต่ำไปสูง", order: { field: "doctor_fee", by: "asc" } },
  { id: 2, name: "ราคา-สูงไปต่ำ", order: { field: "doctor_fee", by: "desc" } },
  {
    id: 3,
    name: "ประสบการณ์แพทย์-มากไปน้อย",
    order: { field: "experience", by: "desc" },
  },
  {
    id: 4,
    name: "ประสบการณ์แพทย์-น้อยไปมาก",
    order: { field: "experience", by: "asc" },
  },
];

export type CancelReasonType = {
  id: number;
  name: string;
  name_en: string;
  value: string;
  namePreVer: string;
  valuePreVer: string;
};

export const DOCTOR_SORT_OPTIONS_EN = [
  // { name: "พร้อมให้บริการ" },
  // { id: 1, name: "ใกล้ฉัน" },
  {
    id: 1,
    name: "Price low to high",
    order: { field: "doctor_fee", by: "asc" },
  },
  {
    id: 2,
    name: "Price high to low",
    order: { field: "doctor_fee", by: "desc" },
  },
  {
    id: 3,
    name: "Work experience high to low",
    order: { field: "experience", by: "desc" },
  },
  {
    id: 4,
    name: "Work experience low to high",
    order: { field: "experience", by: "asc" },
  },
];

export const APIS = {
  CENTER_GROUP_APP: "/appointment/center-group/",
  CENTER_APP: "/appointment/center/",
  DOCTOR_APP: "/appointment/doctor/",
};

export const URLS = {
  SELECT_CLINIC: "/select-clinic",
  APPOINTMENT_FOR: "/appointment-for",
  APPOINTMENT_REASON: "/appointment-reason",
  SELECT_DATETIME: "/select-datetime",
  SUBMIT_REQUEST: "/submit-request",
  CANCEL_APPOINTMENT: "/cancel-appointment",
  SEARCH_DOCTOR: "/search-doctor",
  SELECT_CENTER: "/select-center",
  SELECT_CHECKUP_TYPE: "/select-checkup-type",
  DOCTOR_PROFILE: "/doctor-profile",
  CONFIRM_APPOINTMENT: "/confirm-appointment",
  SELECT_CENTERGROUP: "/select-centergroup",
  SELECT_CHECKUP_HOSPITAL: "/select-checkup-hospital",
  HEALTH_PROBLEM: "/health-problem",
};
